import React from "react"

import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Tooltip,
} from "@coval/ui"

interface UnsavedChangesModalProps {
  isOpen: boolean
  onClose: () => void
  onDiscard: () => void
  onSave: () => void
  isSaving?: boolean
  isDiscardDisabled?: boolean
  discardDisabledReason?: string
  title?: string
  description?: string
  error?: string | null
}

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  isOpen,
  onClose,
  onDiscard,
  onSave,
  isSaving = false,
  isDiscardDisabled = false,
  discardDisabledReason,
  title = "Unsaved Changes",
  description = "You have unsaved changes that will be lost if you leave this page. Would you like to save your changes before leaving, or discard them?",
  error,
}) => {
  const discardButton = (
    <Button
      variant="danger"
      onClick={onDiscard}
      disabled={isSaving || isDiscardDisabled}
    >
      Discard Changes
    </Button>
  )

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => !open && !isSaving && onClose()}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <p className="text-coval-text-muted">{description}</p>
          {error && (
            <div className="mt-3 p-3 bg-coval-danger-surface border border-coval-danger-border rounded-md">
              <p className="text-coval-danger-on-surface text-sm">{error}</p>
            </div>
          )}
        </DialogBody>
        <DialogFooter>
          {isDiscardDisabled && discardDisabledReason ? (
            <Tooltip content={discardDisabledReason} triggerDisabled>
              {discardButton}
            </Tooltip>
          ) : (
            discardButton
          )}
          <Button variant="ghost" onClick={onClose} disabled={isSaving}>
            Cancel
          </Button>
          <Button onClick={onSave} disabled={isSaving}>
            {isSaving ? "Saving..." : "Save Changes"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
